import { path } from 'ramda';

import { types as sdkTypes } from '../../util/sdkLoader';
import { LISTING_PAGE_PENDING_APPROVAL_VARIANT, parse } from '../../util/urlHelpers';
import { fetchMonthlyTimeSlots, fetchReviews, showListing } from '../../ducks/listing.duck';

import { searchSimilarListings } from '../SearchPage/SearchPage.duck';

const { UUID } = sdkTypes;

export const loadData = (params, search) => dispatch => {
  const listingId = new UUID(params.id);

  const ownListingVariants = [LISTING_PAGE_PENDING_APPROVAL_VARIANT];
  if (ownListingVariants.includes(params.variant)) {
    return dispatch(showListing(listingId, true));
  }

  return Promise.all([dispatch(showListing(listingId)), dispatch(fetchReviews(listingId)), dispatch(searchSimilarListings(listingId))]).then(
    responses => {
      if (responses[0] && responses[0].data && responses[0].data.data) {
        const listing = responses[0].data.data;
        const parsedSearch = parse(search);
        const bookingDate = path(['bookingDate'], parsedSearch);

        // Fetch timeSlots.
        // This can happen parallel to loadData.
        // We are not interested to return them from loadData call.
        fetchMonthlyTimeSlots(dispatch, listing, bookingDate);
      }
      return responses;
    }
  );
};
